<template>
    <div class="garanties-list">
        <div class="clients__title">
            Contrats d’Assurance souscrits
        </div>

        <GarantiesFilter @submit="onFilterChanged"/>

        <template v-if="isLoading">
            <Preloader />
        </template>
        <template v-else>
            <div class="clients__table">
                <template v-if="garanties.data.length > 0">
                    <div class="clients__table__item">
                        <div class="clients__table__item--cell">Date</div>
                        <div class="clients__table__item--cell">Nom</div>
                        <div class="clients__table__item--cell" v-if="representative_id">Garantie souscrite</div>
                        <div class="clients__table__item--cell" v-else>Garantie souscrite</div>
                        <div class="clients__table__item--cell">Prix</div>
                        <div class="clients__table__item--cell">Attestation</div>
                      <div class="clients__table__item--cell">Bon</div>
<!--                        <div class="clients__table__item&#45;&#45;cell">Contrat</div>-->
                    </div>
                    <div class="clients__table__item" v-for='garanty in garanties.data'>
                        <div class="clients__table__item--cell">{{parseDate(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parseFullName(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parseTypeGaranty(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parsePrice(garanty)}}</div>
                        <div class="clients__table__item--cell icon-cell">
                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_attestation_pdf(garanty.id)"/>
                        </div>
                      <div class="clients__table__item--cell icon-cell">
                        <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_assurance_pdf(garanty.id)"/>
                      </div>
                        <div class="clients__table__item--cell with-button">
                            <button class="edit" @click="clientDocuments(garanty.client.id)">DOCS</button>
                        </div>
<!--                        <div class="clients__table__item&#45;&#45;cell icon-cell">-->
<!--                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="preview_pdf('garantie/confirmation-pdf/' + garanty.id, '&show_type=stream')"/>-->
<!--                        </div>-->
                    </div>
                </template>
                <template v-else>
                    <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
                </template>

            </div>

            <pagination v-if="representative_id" :data="garanties" @pagination-change-page="getRepresentativeGaranties"></pagination>
            <pagination v-else :data="garanties" @pagination-change-page="getAssuranceGaranties"></pagination>
        </template>
    </div>
</template>

<script>
    import GarantiesFilter from '@/components/GarantiesSouscrites/GarantiesFilter'
    import Preloader from '@/components/Preloader'
    import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';

    export default {
        name: "AssurancesGarantiesList",
        components: {GarantiesFilter, Preloader},
        mixins: [pdfPreviewMixin],
        data() {
            return {
                garanties: {
                    data: []
                },
                filterParams: {
                   pdf: 1,
                },
                sortParams: {
                    sort: 'id|desc',

                },
                isLoading: false,
            }
        },
        computed: {
            mechanic_id() {
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
            representative_id() {
              return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
            },
        },
        watch: {
            'mechanic_id': function() {
                this.getAssuranceGaranties();
            },
            'representative_id': function() {
              this.getRepresentativeGaranties();
            }
        },
        methods: {
            isDealer() {
              return this.$store.getters.isDealer;
            },
            isRepresentative() {
              return this.$store.getters.isRepresentative;
            },
            parseDate(garanty) {
                if (garanty && garanty.created_at) {
                    return this.moment(garanty.created_at).format('DD/MM/Y');
                    // let day = garanty.datesParse.day_created,
                    //     month = garanty.datesParse.month_created,
                    //     year = garanty.datesParse.year_created;
                    // return day + "/" + month + '/' + year;
                }

                return ' - ';
            },
            parsePrice(garanty) {
              if (this.isDealer()) {
                let amount = 0;
                if (+garanty.assistance_price > 0) {
                  amount += +(garanty.price + garanty.assistance_price);
                }
                else {
                  amount = garanty.price || 0;
                }
                return this.roundEURWithoutSymbol(amount) + ' €';
              }
                return (garanty && garanty.price) ? this.roundEURWithoutSymbol(garanty.price) + ' €' : ' - '
            },
            parseFullName(garanty) {
              if (this.isRepresentative()) {
                return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
              }
              else {
                return (garanty) ? garanty.first_name + ' ' + garanty.last_name : ' - ';
              }
            },
            parseTypeGaranty(garanty) {
              if (garanty.garantie_name) {
                return garanty.garantie_name;
              }
              else if (garanty && garanty.category) {
                    switch (+garanty.category)
                    {
                        case 2: return 'Auto'; break;
                        case 3: return 'Moto'; break;
                        case 1: return 'Camping car'; break;
                    }
                }

                return '';
            },
            onFilterChanged(filterParams) {
                this.filterParams = filterParams;
                this.$nextTick(() => {
                    if(this.representative_id) {
                      this.getRepresentativeGaranties();
                    }
                    else {
                      this.getAssuranceGaranties();
                    }
                });
            },
            getAssuranceGaranties(page = 1) {
                this.isLoading = true;
                let url = (this.isDealer()) ? 'garantie/list-assurance?page=' + page : 'garantie/list-assurance?page=' + page,
                    data = {
                        mechanic_id: this.mechanic_id,
                        ...this.filterParams,
                        ...this.sortParams
                    };
                this.apiGet(url, data)
                    .then(response => {
                        this.isLoading = false;
                        this.garanties = response.data;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    })
            },
            getRepresentativeGaranties(page = 1) {
                this.isLoading = true;
                let url = 'garantie/representative-search?page=' + page,
                    data = {
                        representative_id: this.representative_id,
                        ...this.filterParams,
                        ...this.sortParams
                    };
                this.apiGet(url, data)
                    .then(response => {
                        this.isLoading = false;
                        this.garanties = response.data;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    })
            },
            clientDocuments(id) {
                this.$router.push(`/client/${id}/documents`);
            }
        },
        mounted() {
          if (this.representative_id) {
            this.getRepresentativeGaranties();
          }
          else {
            this.getAssuranceGaranties();
          }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/AssurancesGarantiesList.vue